import CobrancaSms from './CobrancaSms';

export default CobrancaSms;
